import { SESSION_IDLE_TIMEOUT_MS, SESSION_LAST_ACTIVE_AT_KEY } from '@/common/constants/Session';

const getStoredExpertData = () => {
  const rawData = localStorage.getItem('data');
  if (!rawData) return {};

  try {
    return JSON.parse(rawData);
  } catch (error) {
    return {};
  }
};

export const hasStoredSession = () => {
  const accessToken = localStorage.getItem('accessToken');
  const expertData = getStoredExpertData();

  return Boolean(accessToken) && Object.keys(expertData).length > 0;
};

export const getSessionLastActiveAt = () => {
  const rawValue = localStorage.getItem(SESSION_LAST_ACTIVE_AT_KEY);
  const lastActiveAt = Number(rawValue);

  if (!rawValue || Number.isNaN(lastActiveAt) || lastActiveAt <= 0) {
    return null;
  }

  return lastActiveAt;
};

export const setSessionLastActiveAt = (lastActiveAt = Date.now()) => {
  localStorage.setItem(SESSION_LAST_ACTIVE_AT_KEY, String(lastActiveAt));
  return lastActiveAt;
};

export const clearSessionLastActiveAt = () => {
  localStorage.removeItem(SESSION_LAST_ACTIVE_AT_KEY);
};

export const isSessionExpired = (now = Date.now()) => {
  if (!hasStoredSession()) return false;

  const lastActiveAt = getSessionLastActiveAt();
  if (!lastActiveAt) return false;

  return now - lastActiveAt >= SESSION_IDLE_TIMEOUT_MS;
};

export const getRemainingSessionTime = (now = Date.now()) => {
  const lastActiveAt = getSessionLastActiveAt();
  if (!lastActiveAt) return SESSION_IDLE_TIMEOUT_MS;

  return Math.max(SESSION_IDLE_TIMEOUT_MS - (now - lastActiveAt), 0);
};
